var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmittedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "url(#paint0_linear_3638_27)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17.7L12.4615 21L24 10",
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3638_27",
    x1: 15.5,
    y1: 0,
    x2: 15.5,
    y2: 31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C056"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.130208,
    stopColor: "#00BB54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009A45"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmittedIcon);
export default __webpack_public_path__ + "static/media/SubmittedIcon.ad6b4a0c37dc119af7d8d47f56af73e9.svg";
export { ForwardRef as ReactComponent };